"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "asOptions", {
  enumerable: true,
  get: function () {
    return _options.asOptions;
  }
});
exports.default = void 0;
Object.defineProperty(exports, "sizeOptions", {
  enumerable: true,
  get: function () {
    return _options.sizeOptions;
  }
});
exports.space = void 0;
exports.useSpace = useSpace;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _options = require("./options");
const _excluded = ["as", "className", "inline", "block", "gap"];
const UX_SPACE_CLASSNAME = 'ux-space';

/**
 * Creates a collection of attributes for spacing styles
 *
 * @param {Object} props - A props configuration object
 * @param {String} props.as - Determines what kind of space to apply
 * @param {String} [props.className] - A class name to include
 * @param {Boolean|String} [props.inline] - Include space in the horizontal direction
 * @param {Boolean|String} [props.block] - Include space in the vertical direction
 * @param {Boolean|String} [props.gap] - Include space in between child elements
 * @returns {String} A collection of classnames
 */
function useSpace(props) {
  const {
    as,
    className,
    inline = false,
    block = false,
    gap = false
  } = props || {};
  const usingAs = Object.values(_options.asOptions).includes(as);
  const usingSize = size => {
    return !usingAs && typeof size === 'string' && Object.values(_options.sizeOptions).includes(size) && size;
  };
  return (0, _classnames.default)(UX_SPACE_CLASSNAME, className, {
    [`${UX_SPACE_CLASSNAME}--as-${as}`]: usingAs,
    [`${UX_SPACE_CLASSNAME}--inline`]: usingAs && Boolean(inline),
    [`${UX_SPACE_CLASSNAME}--block`]: usingAs && Boolean(block),
    [`${UX_SPACE_CLASSNAME}--gap`]: usingAs && Boolean(gap),
    [`${UX_SPACE_CLASSNAME}--inline-${inline}`]: usingSize(inline),
    [`${UX_SPACE_CLASSNAME}--block-${block}`]: usingSize(block),
    [`${UX_SPACE_CLASSNAME}--gap-${gap}`]: usingSize(gap)
  });
}

/**
 * Creates a function which represents a dynamic React component
 *
 * @param {String} TagName - The tag name of the element to use for space
 * @returns {Function} - A function to create a component
 */
function create(TagName) {
  /**
   * Creates a React component using the given tag name
   *
   * @param {Object} props - A props configuration object
   * @param {String} [props.as] - DEPRECATED: Determines the density of the component and its children
   * @param {String} [props.className] - A class name to include
   * @param {Node} [props.children] - Children
   * @param {Boolean|String} [props.inline] - Include space in the horizontal direction: ;
   * @param {Boolean|String} [props.block] - Include space in the vertical direction
   * @param {Boolean|String} [props.gap] - Include space in between child elements
   * @param {Object} ref - Element reference
   * @returns {React.Component} - A functional React component
   */
  const Space = /*#__PURE__*/_react.default.forwardRef(function Space(_ref, ref) {
    let {
        as,
        className,
        inline,
        block,
        gap
      } = _ref,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    return /*#__PURE__*/_react.default.createElement(TagName, (0, _extends2.default)({
      "data-version": "2400.3",
      className: useSpace({
        as,
        className,
        inline,
        block,
        gap
      }),
      ref: ref
    }, rest));
  });
  function deprecated(validator) {
    return function (props, propName) {
      if (propName === 'as' && props[propName]) {
        console.warn(`'as' is deprecated, please use either 'inline' or 'block' with a T-shirt size instead.`);
      }
      for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        rest[_key - 2] = arguments[_key];
      }
      return validator(props, propName, ...rest);
    };
  }

  /**
   *
   * @enum {Object} expected types of properties.
   * @public
   */
  Space.propTypes = {
    /** DEPRECATED: Determines the density of the component and its children */
    as: deprecated(_propTypes.default.oneOf(Object.values(_options.asOptions))),
    /** Children for the component */
    children: _propTypes.default.node,
    /** Classes to apply to component */
    className: _propTypes.default.string,
    /** Include space in the horizontal direction */
    inline: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(Object.values(_options.sizeOptions))]),
    /** Include space in the vertical direction */
    block: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(Object.values(_options.sizeOptions))]),
    /** Include space in between child elements */
    gap: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.oneOf(Object.values(_options.sizeOptions))])
  };
  return Space;
}
const space = exports.space = new Proxy(function () {}, {
  get: function get(target, prop) {
    // Deliberately not using hasOwnProperty to catch things like __proto__
    if (!String(prop).startsWith('_') && typeof target[prop] === 'undefined') {
      // Cache access by creating a key with value
      target[prop] = create(prop);
    }
    // Always return thing at that key, either undefined or thing set
    return Reflect.get(...arguments);
  }
});
var _default = exports.default = space;